/**
 * Task WP: platform switch "店家 WhatsApp 官方接口（Meta，付费）" — 平台管理 → 店家 → 功能开关, and the shop texts shown while it is off.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["wp.nt.ruleEmail","Booking and receipt messages are sent by e-mail.","预约与收据消息通过邮件发送。"],
  ["wp.sw.title","Feature switches","功能开关"],
  ["wp.sw.sub","Platform-wide: applies to every shop, web and app.","全平台生效：适用于所有店家（网页与 App）。"],
  ["wp.sw.waOfficial","Shop WhatsApp official API (Meta, paid)","店家 WhatsApp 官方接口（Meta，付费）"],
  ["wp.sw.waOfficialHint","Shops connect their own WhatsApp Business number (Facebook one-click or manual), Meta templates, WhatsApp usage and quota. Meta bills each shop per message.","店家连接自己的 WhatsApp Business 号码（Facebook 一键连接或手动连接）、Meta 模板、WhatsApp 用量与额度。Meta 按条向店家收费。"],
  ["wp.sw.on","On — shops see and can use it","已开启 — 店家可见并可使用"],
  ["wp.sw.off","Off — hidden for every shop; messages go by linked WhatsApp (free) or e-mail","已关闭 — 所有店家均不可见；消息改由 WhatsApp 辅助提醒（免费）或邮件发送"],
  ["wp.sw.unaffected","Not affected: the free “WhatsApp reminders” (linked device) and the “Send with WhatsApp” buttons.","不受影响：免费的「WhatsApp 辅助提醒」（关联设备）和「用 WhatsApp 发送」按钮。"],
  ["wp.sw.connected","{n} shop(s) connected it before — their settings are kept and used again when switched back on.","{n} 家店铺此前已连接 — 其设置会保留，重新开启后继续使用。"],
  ["wp.sw.default","Not saved yet — using the server default.","尚未保存 — 当前使用服务器默认值。"],
  ["wp.sw.turnOn","Turn on","开启"],
  ["wp.sw.turnOff","Turn off","关闭"],
  ["wp.sw.confirmOffTitle","Turn off the official WhatsApp API?","关闭 WhatsApp 官方接口？"],
  ["wp.sw.confirmOff","Every shop stops seeing WhatsApp connect, templates and usage, and no message is sent through the official API (also for shops already connected). Their data is kept.","所有店家将看不到 WhatsApp 连接、模板与用量，也不会再通过官方接口发送任何消息（已连接的店家亦然）。其数据会保留。"],
  ["wp.sw.confirmOnTitle","Turn on the official WhatsApp API?","开启 WhatsApp 官方接口？"],
  ["wp.sw.confirmOn","Shops see WhatsApp connect, templates, usage and quota again; shops that were connected send through it again.","店家将重新看到 WhatsApp 连接、模板、用量与额度；已连接的店家会重新通过官方接口发送。"],
  ["wp.sw.saved","Saved","已保存"],
  ["wp.sw.pillOn","On","已开启"],
  ["wp.sw.pillOff","Off","已关闭"],
] as const;

export type WpKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<WpKey, string>;

export const taskWP = { en: col(1), zh: col(2), ms: col(1) };
